(() => {
  const configElement = document.getElementById('StorefrontIntegrationConfig');
  let config = {};

  try {
    config = configElement ? JSON.parse(configElement.textContent) : {};
  } catch (error) {
    config = {};
  }

  const fallback = document.querySelector('[data-storefront-fallback]');
  const panel = fallback?.querySelector('.storefront-fallback__panel');
  let trigger = null;

  const isOpen = () => fallback?.classList.contains('is-open');

  const closeFallback = () => {
    if (!fallback || !isOpen()) return;
    fallback.classList.remove('is-open');
    fallback.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('storefront-fallback-open');
    if (window.location.hash === '#newsletter-fallback') {
      history.replaceState(null, document.title, `${window.location.pathname}${window.location.search}`);
    }
    trigger?.focus();
  };

  const openFallback = (source) => {
    if (!fallback || !panel) return;
    trigger = source || document.activeElement;
    fallback.classList.add('is-open');
    fallback.setAttribute('aria-hidden', 'false');
    document.body.classList.add('storefront-fallback-open');
    window.setTimeout(() => panel.focus(), 0);
  };

  const openKlaviyo = () => {
    if (!config.klaviyoEnabled || !config.klaviyoFormId) return false;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', config.klaviyoFormId]);
    return true;
  };

  document.addEventListener('click', (event) => {
    const action = event.target.closest('[data-storefront-action]');
    if (action?.dataset.storefrontAction === 'newsletter') {
      event.preventDefault();
      if (!openKlaviyo()) openFallback(action);
      return;
    }

    if (event.target.closest('[data-storefront-fallback-close]')) {
      event.preventDefault();
      closeFallback();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeFallback();
  });

  window.addEventListener('hashchange', () => {
    if (window.location.hash === '#newsletter-fallback') openFallback(document.activeElement);
  });

  if (window.location.hash === '#newsletter-fallback') openFallback(document.activeElement);
})();
